import type { FC } from 'react'

import { useT } from '@/i18n'
import { Button } from '@/components/generals/button'
import { Reveal } from '@/components/generals/reveal'
import { Magnetic } from '@/components/generals/magnetic'
import { Container } from '@/components/generals/container'
import { Eyebrow } from '@/components/generals/section-heading'
import { AnimatedHeading } from '@/components/generals/animated-heading'

export const CtaSection: FC = () => {
    const t = useT()

    return (
    <section className='relative overflow-hidden bg-navy-deep py-14 text-parchment md:py-20'>
        <div className='pointer-events-none absolute inset-0 bg-stars opacity-[0.07]' />
        <div className='pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent' />

        <Container className='relative'>
            <div className='mx-auto flex max-w-3xl flex-col items-center text-center'>
                <Eyebrow light>{t.cta.eyebrow}</Eyebrow>

                <AnimatedHeading
                    onScroll
                    text={t.cta.title}
                    className='mt-6 text-balance text-3xl font-semibold text-parchment sm:text-4xl md:text-5xl'
                />

                <Reveal className='mt-10 flex flex-wrap items-center justify-center gap-4' delay={0.1}>
                    <Magnetic>
                        <Button href='/kurse' variant='gold' size='lg' withArrow>
                            {t.cta.primary}
                        </Button>
                    </Magnetic>
                    <Button href='/kontakt' variant='outline-light' size='lg'>
                        {t.cta.secondary}
                    </Button>
                </Reveal>
            </div>
        </Container>
    </section>
    )
}
